export const OrderDetails = ({ paymentResult, country }) => (
	<div className="w-full max-w-[700px] bg-white rounded-xl shadow-sm border border-gray-200 p-6 space-y-4">
		<h2 className="text-lg font-medium">Order Details</h2>
		<div className="space-y-3 text-gray-600">
			<div className="flex items-center justify-between">
				<span>Status</span>
				<span className="font-medium">{paymentResult?.status}</span>
			</div>
			<div className="flex items-center justify-between">
				<span>Bill Id</span>
				<span className="font-medium">{paymentResult?.id}</span>
			</div>
			<div className="flex items-center justify-between">
				<span>Email</span>
				<span className="font-medium">
					{paymentResult?.payer.email_address}
				</span>
			</div>
			<div className="flex items-center justify-between">
				<span>Name</span>
				<span className="font-medium">
					{paymentResult?.payer.name.given_name}{" "}
					{paymentResult?.payer.name.surname}
				</span>
			</div>
			<div className="flex items-center justify-between border-t pt-3">
				<span>Total</span>
				<span className="font-medium text-lg">
					${paymentResult?.purchase_units[0].amount.value}{" "}
					{country === "USA" ? "USD" : "CAD"}
				</span>
			</div>
		</div>
	</div>
);
